import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext.ts'
import {usePlayerValidators} from './usePlayerValidators.ts'
import {MechanicValidatorProgressCards} from '@colonist/game-mechanic-validators'
import {useMapValidator} from './useMapValidator.ts'

export const useMechanicValidatorProgressCards = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicProgressCardsState = useGameStore((state) => state.gameState.mechanicProgressCardsState)

    return useMemo(() => {
        if(!mechanicProgressCardsState) return undefined
        return new MechanicValidatorProgressCards(playerValidators, mapValidator, mechanicProgressCardsState)
    }, [playerValidators, mapValidator, mechanicProgressCardsState])
}
